module.exports = __webpack_public_path__ + "img/welcome3.12616522.png";